import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { baseIconStyle, roleModalWithTimerConfig } from './role-modals-constant'

export const RoleModalWithTimer = ({ type, isQueueEmpty, onComplete = () => {} }) => {
  const navigate = useNavigate()

  const [countdown, setCountdown] = useState(5)
  const config = roleModalWithTimerConfig[type] || roleModalWithTimerConfig.DEFAULT
  const goHome = () => {
    navigate('/home')
  }

  useEffect(() => {
    if (!isQueueEmpty) {
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer)
            onComplete()
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [isQueueEmpty])

  return (
    <Box display="flex" flexDirection="column" gap="10px" alignItems="center">
      <Box sx={{ ...baseIconStyle, backgroundColor: config.backgroundColor }}>{config.icon}</Box>
      <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>{config.title}</Typography>
      {type === 'DEFAULT' ? (
        <>
          <Typography variant="body2">{config.description}</Typography>
          <Button variant="outlined" fullWidth onClick={() => window.location.reload()}>
            {config.buttonLabel}
          </Button>
        </>
      ) : (
        <Typography variant="body2">
          {isQueueEmpty ? config.descriptionEmpty : `Следующая заявка назначится через ${countdown} сек`}
        </Typography>
      )}
      {isQueueEmpty && (
        <Button variant="outlined" fullWidth onClick={goHome}>
          На главную
        </Button>
      )}
    </Box>
  )
}
